import { makeStyles } from '@material-ui/core/styles';

export default (params: any) => {
    const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          height: '100vh'
        }
    }));

    return useStyles;
}